import toast from "react-hot-toast";

export const successToast = (message) => {
  toast.success(message, {
    style: {
      background: "#198351",
      padding: "16px",
      color: "#ffffff",
    },
    iconTheme: {
      primary: "#198351",
      secondary: "#ffffff",
    },
  });
};

export const errorToast = (message) => {
  toast.error(message, {
    style: {
      background: "#DC0813",
      padding: "16px",
      color: "#ffffff",
    },
    iconTheme: {
      primary: "#DC0813",
      secondary: "#ffffff",
    },
  });
};

export const warningToast = (message) => {
  toast.success(message, {
    style: {
      background: "#F39D12",
      padding: "16px",
      color: "#ffffff",
    },
    iconTheme: {
      primary: "#F39D12",
      secondary: "#ffffff",
    },
    icon: "⚠️",
  });
};

export const infoToast = (message) => {
  toast.success(message, {
    style: {
      background: "#1E8DEA",
      padding: "16px",
      color: "#ffffff",
    },
    iconTheme: {
      primary: "#1E8DEA",
      secondary: "#ffffff",
    },
    icon: "ⓘ",
  });
};
